import React from "react"

type Props = {
  className?: string
}

const DataIcon = ({ className }: Props) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M4.16675 13.2405L8.39258 9.01467C8.71841 8.68884 9.24591 8.68884 9.57091 9.01467L11.3551 10.7988C11.6809 11.1247 12.2084 11.1247 12.5334 10.7988L17.5001 5.83301"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.2776 5.83301H17.5001V8.05551"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.5001 17.4412H1.60425V2.68457"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default DataIcon
